export default {
  FIELD_MODEL_DIALOG_SET_STATE: 'FIELD_MODEL_DIALOG_SET_STATE'
};
